import './Button.scss';
import React from 'react';
import { mergeSx } from '../_internal/styleProps';

function Button({
  children,
  className = '',
  disabled = false,
  fullWidth = false,
  endIcon,
  iconEnd = endIcon,
  iconStart,
  loading = false,
  size = 'medium',
  startIcon,
  style,
  sx,
  type = 'button',
  variant = 'secondary',
  ...rest
}) {
  const normalizedVariant = {
    contained: 'primary',
    outlined: 'secondary',
    text: 'tertiary',
  }[variant] || variant;
  const buttonClassName = [
    'custom-button',
    `custom-button--${normalizedVariant}`,
    `custom-button--${size}`,
    fullWidth ? 'custom-button--full' : '',
    loading ? 'custom-button--loading' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      className={buttonClassName}
      disabled={disabled || loading}
      type={type}
      style={mergeSx(sx, style)}
      {...rest}
    >
      {loading && <span className="custom-button__spinner" aria-hidden="true" />}
      {(iconStart || startIcon) && <span className="custom-button__icon">{iconStart || startIcon}</span>}
      <span className="custom-button__label">{children}</span>
      {iconEnd && <span className="custom-button__icon">{iconEnd}</span>}
    </button>
  );
}

export default Button;
